module.exports = __webpack_public_path__ + "static/media/background-download.40b1361f.svg";